import type { SliderProps } from '@nuxt/ui';
import type { ButtonProps, InputProps } from '#layers/ui';

type BlockColor = NonNullable<ButtonProps['color']> & NonNullable<InputProps['color']> & NonNullable<SliderProps['color']>;
type BlockControlSize = NonNullable<ButtonProps['size']> & NonNullable<InputProps['size']> & NonNullable<SliderProps['size']>;
type BlockInputVariant = NonNullable<InputProps['variant']>;

export const BLOCK_COLOR_OPTIONS = ['primary', 'success', 'info', 'warning', 'error', 'neutral'] as const satisfies readonly BlockColor[];
export const BLOCK_CONTROL_SIZE_OPTIONS = ['xs', 'sm', 'md', 'lg', 'xl'] as const satisfies readonly BlockControlSize[];
export const BLOCK_INPUT_VARIANT_OPTIONS = ['outline', 'soft', 'subtle', 'ghost', 'none'] as const satisfies readonly BlockInputVariant[];
